import PrivacyPolicy from './../components/sections/PrivacyPolicy/PrivacyPolicy';

const PrivacyPolicyPage = () => {
  return (
    <>
      <PrivacyPolicy />
    </>
  );
};

export default PrivacyPolicyPage;